import { Fragment } from "react";
import { Card, Container, Row } from "react-bootstrap";
import useSharedData from "../../../hooks/useSharedData";
import FooterPostup from "../../public/footer/footer";
import Menu from "../../public/menu/menu";
import Address from "./components/order/Address";
import AgentCollect from "./components/order/AgentCollect";
import FormShipment from "./components/order/FormShipment";
import ShipmentInfo from "./components/order/ShipmentInfo";
import Title from "./components/order/Title";

function OrderShipment() {
  const { isAgent } = useSharedData();

  return (
    <Fragment>
      <Menu />
      <div className="new-letter-style">
        <Container fluid className="fluid">
          {isAgent && <AgentCollect />}
          <Title />

          <div className="loginFormCol">
            <Card className="loginForm">
              <Row className="row-cols-xl-2 row-cols-lg-2 row-cols-md-2 row-cols-1 rtl-all">
                <Address senderOrgetter={0} />
                <Address senderOrgetter={1} />
              </Row>

              <ShipmentInfo />

              <FormShipment />
            </Card>
          </div>
        </Container>
      </div>
      <FooterPostup />
    </Fragment>
  );
}

export default OrderShipment;
